import {useDispatch} from 'react-redux';

import {useAccountSettingsState} from 'app/settings/api';
import {
  showToastNotification,
  showUpgradeModal as showUpgradeModalAction,
  UPGRADE_MODALS,
} from 'app/toasts/slice';

export function useUpgradeModal() {
  const dispatch = useDispatch();
  const {is_peruser} = useAccountSettingsState().data!;

  function showUpgradeModalIfNotPerUser<R>(
    modalType: UPGRADE_MODALS,
    actionToProtect?: () => R
  ): R | undefined {
    if (!is_peruser) {
      dispatch(showUpgradeModalAction(modalType));
    } else if (actionToProtect != null) {
      return actionToProtect();
    }
  }

  function showUpgradeModal(
    pickModalType: (modalType: typeof UPGRADE_MODALS) => UPGRADE_MODALS
  ) {
    dispatch(showUpgradeModalAction(pickModalType(UPGRADE_MODALS)));
  }

  return {showUpgradeModalIfNotPerUser, showUpgradeModal};
}

export function useNotifications() {
  const dispatch = useDispatch();
  return {
    showToastNotification: (
      ...args: Parameters<typeof showToastNotification>
    ) => dispatch(showToastNotification(...args)),
  };
}
